import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { useState } from "react";
import { fetch } from "../../../lib/fetch";
import { extractFromMultiName } from "../../Locations/utils";

type Destination = {
  names: string;
};

export const Destination = ({ defaultValue }: { defaultValue?: string }) => {
  const [destination, setDestination] = useState<Destination | null>(defaultValue ? { names: defaultValue } : null);

  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Destination</h3>
      <FormField<FiltersFormT, "endLocation">
        name="endLocation"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Combobox
                  className="flex w-96"
                  loadOptions={(query) => {
                    const data = fetch<{ data: Destination[]; success: boolean }>(
                      `/api/locations/countries?${query ? `&filter=${query}` : ""}`,
                    ).then((r) => r.data);

                    return data;
                  }}
                  placeholder="Search for destination..."
                  value={destination}
                  onChange={(v) => {
                    if (v && extractFromMultiName(v.names) !== extractFromMultiName(destination?.names)) {
                      setDestination(v);
                      field.onChange(v.names);
                    } else {
                      setDestination(null);
                      field.onChange("");
                    }
                  }}
                  renderOption={(r) => extractFromMultiName(r.names)}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
